import HeaderBack from "./HeaderBack"

export const LayoutBackHeader: React.FC = ({ children, ...rest }: any) => {
    return <div>
        <HeaderBack />
        {children}
    </div>
}

export default LayoutBackHeader